import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface TabConfig {
  value: string;
  label: string;
  href: string;
}

interface ModuleTabsProps {
  tabs: TabConfig[];
  className?: string;
}

export function ModuleTabs({ tabs, className }: ModuleTabsProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentTab = tabs.find(t => t.href === location.pathname)?.value || tabs[0]?.value;

  return (
    <Tabs value={currentTab} className={className}>
      <TabsList>
        {tabs.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            onClick={() => navigate(tab.href)}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
